<template>
  <div id='bd-top'>
    <img class="avatar" width="35" height="35" :alt="userCurrentBlock.blockedUser.nickname" :src="userCurrentBlock.blockedUser.avatar">
    <span class="nickname">{{ userCurrentBlock.blockedUser.nickname }}</span>
    <span class="wrapper">
      <el-button :disabled="disabled" @click="cancelBlock" type="danger" size="mini">{{ $t('cancelBlock') }}</el-button>
    </span>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import * as https from '@/apis/http'
// import bus from '@/util/eventbus'
// const constants = require('@/util/constants')

export default {
  name: 'bd-top',
  data () {
    return {
      //
    }
  },
  computed: {
    ...mapGetters([ 'userCurrentBlock', 'showAuthority' ]),
    disabled () {
      return this.userCurrentBlock.bid.trim().length === 0
    }
  },
  methods: {
    // ...mapActions('mqtt', [ 'sendMessageProtobuf' ]),
    ...mapActions([ 'removeBlock' ]),
    cancelBlock () {
      console.log('cancelBlock')
      //
      this.$confirm(this.$t('cancelBlock'), this.$t('tip'), {
        confirmButtonText: this.$t('ok'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        // 关闭会话
        let bid = this.userCurrentBlock.bid
        this.removeBlock(bid)
      }).catch(() => {
      })
    },
  },
  mounted () {
    //
  }
}
</script>

<style scoped>
#bd-top {
  width: 100%;
  height: 50px;
  border-bottom:solid 0.1px #dddddd;
}
#bd-top .avatar {
  margin-top: 7px;
  margin-left: 10px;
  float: left;
}
#bd-top .nickname {
  max-width: 250px;
  margin-left: 5px;
  margin-top: 12px;
  float: left;
  font-size: 12px;
}
#bd-top .wrapper {
  float: right;
  margin-right: 10px;
  margin-top: 10px;
  overflow: hidden;
  height: 40px;
}
.demo-drawer__content {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 5px;
  overflow-y: scroll;
}
.demo-drawer__footer {
  position: absolute;
  bottom: 5px;
}
</style>
